import React, { useState, useEffect, useRef } from 'react';
import useAuth from 'src/hooks/useAuth';

const SessionExpire = () => {
  const [countdown, setCountdown] = useState(5);
  const { logout } = useAuth();
  const logoutExecuted = useRef(false);

  useEffect(() => {
    // Previne múltiplas execuções do logout
    // if (countdown === 0 && !logoutExecuted.current) {
    //   logoutExecuted.current = true;
    //   alert('Sua sessão expirou. Você será redirecionado para a página de login.');
    //   logout();
    //   return;
    // }

    // Só continua a contagem se não tiver chegado a zero
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(prevCount => prevCount - 1);
      }, 1000);
      
      // Limpa o temporizador quando o componente for desmontado
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h1 className="text-2xl font-bold mb-4">Sua sessão expirou</h1>
       
        <div className="my-8">
          <span className="text-6xl font-bold text-blue-600">{countdown}</span>
        </div>
       
        <p className="mb-4">
          Você será redirecionado para a página de login em {countdown} segundo{countdown !== 1 ? 's' : ''}.
        </p>
       
        <p className="text-gray-600">
          Por motivos de segurança, sua sessão foi encerrada devido à inatividade.
        </p>
      </div>
    </div>
  );
};

export default SessionExpire;